import BMPRenderer from "./bmp";
import HTMLRenderer from "./html";
import JPGRenderer from "./jpg";
import MSDocRenderer from "./msdoc";
import MSGRenderer from "./msg";
import PDFRenderer from "./pdf";
import PNGRenderer from "./png";
import TIFFRenderer from "./tiff";
import TXTRenderer from "./txt";

export const DocViewerRenderers = [
  BMPRenderer,
  HTMLRenderer,
  JPGRenderer,
  MSDocRenderer,
  MSGRenderer,
  PDFRenderer,
  PNGRenderer,
  TIFFRenderer,
  TXTRenderer,
];
